import { userRoles } from 'modules/auth/constants';

const isAdmin = (role) => [userRoles.admin].includes(role);
export const isPartner = (role) => [userRoles.partner].includes(role);
export const isClient = (role) => [userRoles.client].includes(role);
export const isCompanyAdmin = (role) => [userRoles.company_admin].includes(role);
export const isPartnerAdmin = (role) => [userRoles.partner_admin].includes(role);

export default isAdmin;
